import { render, staticRenderFns } from "./AddTeamMemberDialog.vue?vue&type=template&id=54ba8e3e"
import script from "./AddTeamMemberDialog.vue?vue&type=script&lang=js"
export * from "./AddTeamMemberDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports